import { FCX } from '@datassential/platform-ui-lib';
import cn from 'classnames';
import { IconArrowBottom } from '@icons';
import Icon from '@components/Icon/Icon';

interface InstantChartsColumnRowProps {
    label: string;
    isSelected?: boolean;
    isMatched?: boolean;
    matchCount: number;
    onClick?: () => void;
}

export const InstantChartsColumnRow: FCX<InstantChartsColumnRowProps> = ({
    label,
    isSelected,
    isMatched,
    matchCount,
    onClick,
    testId,
    className
}) => (
    <div
        className={cn('InstantCharts__row', {
            'is-selected': isSelected,
            'is-matched': isMatched,
        }, className)}
        onClick={onClick}
        data-testid={testId}
    >
        <span
            className="InstantCharts__row-label"
            dangerouslySetInnerHTML={{ __html: label }}
        />
        <div className="InstantCharts__row-chevron">
            <Icon>
                <IconArrowBottom />
            </Icon>
        </div>
        {matchCount > 0 && (
            <span className="InstantCharts__row-count">{matchCount}</span>
        )}
    </div>
);
